module.exports = __webpack_public_path__ + "img/sv68.5b3eedf1.svg";